export const CAFETERIA_SETTINGS_READONLY_FOR_SCHOOLS = 'cafeteria_settings_readonly_for_schools' as const
export const USE_PIN = 'use_pin' as const
export const FREE_CAFE_ORDER_DAY = 'free_cafe_order_day' as const
export const ORDER_TARGETS_ENABLED = 'order_targets_enabled' as const
export const ENABLE_SUBSIDIES_FOR_ORDERS = 'enable_subsidies_for_orders' as const
export const ENABLE_SUBSIDIES_FOR_SINGLE_SALES = 'enable_subsidies_for_single_sales' as const
export const ALLOW_CASH_SALES = 'allow_cash_sales' as const
export const ALLOW_BANK_CARD_SALES = 'allow_bank_card_sales' as const
export const ALLOW_GUESS_SALES = 'allow_guess_sales' as const
export const ALLOW_PARENTS_TO_PARTICIPATE_IN_ORDERS = 'allow_parents_to_participate_in_orders' as const
export const ALLOW_STUDENTS_TO_PARTICIPATE_IN_ORDERS = 'allow_students_to_participate_in_orders' as const
export const CAFETERIA_ENABLED = 'cafeteria_enabled' as const
export const ALLOW_BANK_CARD_SALES_IN_TERMINAL = 'allow_bank_card_sales_in_terminal' as const

// not_used
// export const USE_FOOD_MODE: 'use_food_mode' = 'use_food_mode';
// export const ENABLED_ALLOW_CASH_SALES: 'enabled_allow_cash_sales' = 'enabled_allow_cash_sales';
// export const FOOD_MODES: 'food_modes' = 'food_modes';
